<template>
  <!-- 负责人 -->
  <div>
    <div class="fourthStep">
      <!-- <el-form
        ref="extTable"
        class="demo-ruleForm"
        :model="{ extTable }"
        label-width="100px"
      >
        <el-form-item class="addTabIndex" label-width="0px" label="" prop=""> -->
      <el-table border :data="extTable" class="" max-height="99999">
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="150"
          prop="personName"
          label="姓名"
        >
          <!-- <template slot-scope="scope">
                <el-form-item :prop="`extTable.${scope.$index}.personName`">
                  <el-input
                    v-model="scope.row.personName"
                    v-if="noDisabled"
                    placeholder="请输入"
                    clearable
                    maxlength="18"
                  />
                  <div v-else>{{ scope.row.personName }}</div>
                </el-form-item>
              </template> -->
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="100"
          prop="personAge"
          label="年龄"
        >
          <!-- <template slot-scope="scope">
                <el-form-item :prop="`extTable.${scope.$index}.personAge`">
                  <el-input
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    v-model="scope.row.personAge"
                    v-if="noDisabled"
                    placeholder="请输入"
                    clearable
                  />
                  <div v-else>{{ scope.row.personAge }}</div>
                </el-form-item>
              </template> -->
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="idCard"
          label="证件号码"
          min-width="200"
        >
          <!-- <template slot-scope="scope">
                <el-form-item :prop="`extTable.${scope.$index}.idCard`">
                  <el-input
                    oninput="value=value.replace(/[^0-9a-zA-Z.]/g,'')"
                    v-model="scope.row.idCard"
                    placeholder="请输入"
                    v-if="noDisabled"
                    clearable
                    maxlength="18"
                  />
                  <div v-else>{{ scope.row.idCard }}</div>
                </el-form-item>
              </template> -->
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="170"
          prop="packPostTitle"
          label="拟在本包件工程任职"
        >
          <!-- <template slot-scope="scope">
                <el-form-item :prop="`extTable.${scope.$index}.packPostTitle`">
                  <el-input
                    v-model="scope.row.packPostTitle"
                    placeholder="请输入"
                    v-if="noDisabled"
                    clearable
                    maxlength="18"
                  />
                  <div v-else>{{ scope.row.packPostTitle }}</div>
                </el-form-item>
              </template> -->
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="150"
          prop="techPostTitle"
          label="技术职称"
        >
          <!-- <template slot-scope="scope">
                <el-form-item :prop="`extTable.${scope.$index}.techPostTitle`">
                  <el-input
                    v-model="scope.row.techPostTitle"
                    placeholder="请输入"
                    clearable
                    v-if="noDisabled"
                    maxlength="18"
                  />
                  <div v-else>{{ scope.row.techPostTitle }}</div>
                </el-form-item>
              </template> -->
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="100"
          prop="workYear"
          label="工作年限"
        >
          <!-- <template slot-scope="scope">
                <el-form-item :prop="`extTable.${scope.$index}.workYear`">
                  <el-input
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    v-model="scope.row.workYear"
                    v-if="noDisabled"
                    placeholder="请输入"
                    clearable
                  />
                  <div v-else>{{ scope.row.workYear }}</div>
                </el-form-item>
              </template> -->
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="150"
          prop="contctExperYear"
          label="类似施工经验年限"
        >
          <!-- <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.contctExperYear`"
                >
                  <el-input
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    v-model="scope.row.contctExperYear"
                    placeholder="请输入"
                    v-if="noDisabled"
                    clearable
                  />
                  <div v-else>{{ scope.row.contctExperYear }}</div>
                </el-form-item>
              </template> -->
        </el-table-column>
        <el-table-column
          fixed="right"
          width="80px;"
          v-if="noDisabled"
          prop="remark"
          label="操作"
        >
          <template slot-scope="scope">
            <span
              style="color: #0089EF;cursor: pointer;"
              @click="deleteItem(scope)"
              >删除</span
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- </el-form-item>
        <el-form-item v-if="noDisabled" label-width="0px" label="">
          <div class="addBtn" @click="addTable()">+{{ titles }}</div>
        </el-form-item>
      </el-form> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    extTable: {
      type: Array,
      default: () => []
    },
    titles: {
      type: String,
      default: "添加人员"
    },
    noDisabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      checkOut: false
    };
  },
  methods: {
    // executor (resolve, reject) {
    //   let rand = Math.random()
    //   console.log(1)
    //   console.log(rand)
    //   if (rand > 0.5) {
    //     resolve()
    //   } else {
    //     reject()
    //   }
    // },

    ruleFun(resolve, reject) {
      this.$refs["extTable"].validate(valid => {
        if (valid) {
          this.checkOut = true;
          resolve();
        } else {
          console.log("error submit!!");
          this.checkOut = false;
          reject();
        }
      });
    },
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1,
          attribute1: "01"
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1,
          attribute1: "01"
        });
      }
      this.$parent.$emit("el.form.change");
    },
    deleteItem(scope) {
      console.log(this.extTable, "this.extTable.....");
      console.log(scope.$index, "scope.....");
      // this.extTable.filter((item, index) => {
      //   if (item.id === scope.row.id) {
      this.extTable.splice(scope.$index, 1);
      // }
      // });
      // this.$parent.$emit("el.form.change");
    },
    // 上一步
    lastStep() {
      this.$emit("getStep", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-form-item__content .el-button {
  width: 82px;
  height: 40px;
  background: #0089ef;
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.el-form-item__content .stopBtn {
  border: 1px solid #0089ef;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0089ef;
}

.addBtn {
  cursor: pointer;
  margin: 0px 0px 10px 0px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}

.addTabIndex /deep/.el-table {
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 60px !important;
  }
  // th:nth-child(6) > .cell:before {
  //   content: "";
  //   margin-right: 5px;
  // }
  th:nth-child(1) > .cell:before {
    content: "";
    margin-right: 5px;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }
  .el-table-row .hover-row {
    background: #eee !important;
  }
}
.demo-ruleForm {
  width: 100%;
  /deep/ .el-form-item__content {
    width: 100%;
  }
}
</style>
